// Hjälpfunktioner för delningsknapparna: laddar tredjepartsskripten för
// Google Classroom och Microsoft Teams en gång och väntar in deras globaler.
//
// Officiell dokumentation:
// - Classroom: https://developers.google.com/workspace/classroom/guides/sharebutton
//   (apis.google.com/js/platform.js → gapi.sharetoclassroom.render)
// - Teams: https://learn.microsoft.com/en-us/microsoftteams/platform/concepts/build-and-test/share-to-teams-from-web-apps
//   (teams.microsoft.com/share/launcher.js → shareToMicrosoftTeams.renderButtons)

declare global {
  interface Window {
    gapi?: {
      sharetoclassroom?: {
        render: (element: HTMLElement, options: { url: string; size?: number }) => void
      }
    }
    shareToMicrosoftTeams?: {
      renderButtons: (options?: { elements: HTMLElement[] }) => void
    }
  }
}

const laddadeSkript = new Map<string, Promise<void>>()

export function laddaSkript(src: string): Promise<void> {
  const befintligt = laddadeSkript.get(src)
  if (befintligt) return befintligt
  const laddning = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => {
      laddadeSkript.delete(src)
      reject(new Error(`Kunde inte ladda ${src}`))
    }
    document.head.appendChild(script)
  })
  laddadeSkript.set(src, laddning)
  return laddning
}

/** Pollar tills `hamta` returnerar ett värde (skriptens globaler dyker upp
 *  en stund efter onload) eller tiden går ut. */
export function vantaPa<T>(hamta: () => T | undefined | null, timeoutMs = 6000): Promise<T> {
  return new Promise((resolve, reject) => {
    const start = Date.now()
    const forsok = () => {
      const varde = hamta()
      if (varde) {
        resolve(varde)
      } else if (Date.now() - start > timeoutMs) {
        reject(new Error('Tidsgräns'))
      } else {
        setTimeout(forsok, 100)
      }
    }
    forsok()
  })
}

/** Reservlänkar om tredjepartsskripten inte kan laddas (t.ex. blockerade
 *  i skolnätverk) — samma delning via respektive produkts webbadress. */
export const KLASSRUM_DELNINGSLANK = (url: string) =>
  `https://classroom.google.com/share?url=${encodeURIComponent(url)}`
export const TEAMS_DELNINGSLANK = (url: string, text: string) =>
  `https://teams.microsoft.com/share?href=${encodeURIComponent(url)}&msgText=${encodeURIComponent(text)}`
